<ion-item lines="none" *ngIf="ionItemWrap; else unwrapped">
    <div class="full-width">
        <ng-content *ngTemplateOutlet="unwrapped"></ng-content>
    </div>
</ion-item>

<ng-template #unwrapped>
    <div [formGroup]="form">
        <ion-input
            class="input input-text ion-margin-bottom"
            #phoneInput
            [label]="label"
            type="tel"
            [placeholder]="placeholder"
            (ionInput)="formatNum($event)"
            [value]="formattedNumber"
            [ngClass]="{
                'invalid-input-button': isInvalidBorderDisplay
            }"
            [autocomplete]="autocomplete"
            [class]="inputClasses"
            labelPlacement="stacked"
            [helperText]="helperText"
            [errorText]="errorText"
            [formControlName]="controlName || null" />

        <div
            *ngIf="
                controlName && form.get(controlName) && form.get(controlName)?.dirty && form.get(controlName)?.errors
            ">
            <p class="text-danger text-midsmall" *ngIf="form.get(controlName)?.errors?.['required']">
                {{ label.replace('*', '') }} is required.
            </p>
        </div>

        <ng-content select="[formMessages]"></ng-content>

        <div class="invalid-text">
            <ng-content select="[formErrorMessages]"></ng-content>
        </div>
    </div>
</ng-template>
